import { Box } from '@chakra-ui/react';
import {
  getTokens,
  Tag,
  Typography,
  XStack,
  YStack,
} from '@shinetools/sunshine-universal';

import { type FCWithChildren } from 'common/types';

type PlanCardProps = {
  title: string;
  description?: string;
  highlight?: string;
  isMobile?: boolean;
  variant?: 'small' | 'large';
};

export const PlanCard: FCWithChildren<PlanCardProps> = ({
  children,
  description,
  highlight,
  isMobile = false,
  title,
  variant = 'large',
}) => {
  const padding =
    getTokens().space[variant === 'small' ? '$space.20' : '$space.32'].val;

  return (
    <YStack
      $large={{
        borderWidth: 0,
        flexBasis: 0,
      }}
      backgroundColor={isMobile && highlight ? '$grey.100' : 'white'}
      borderBottomLeftRadius={0}
      borderBottomRightRadius={0}
      borderColor="$grey.300"
      borderTopLeftRadius={8}
      borderTopRightRadius={8}
      borderWidth={1}
      flex={1}
      height="100%"
      justifyContent="space-between"
      key={title}
      padding={padding}
      position="relative"
    >
      <YStack
        gap="$space.4"
        marginBottom={variant === 'small' ? '$space.4' : '$space.32'}
      >
        <XStack alignItems="center" gap="$space.16">
          <Typography.HeaderNumber>{title}</Typography.HeaderNumber>
          {highlight ? (
            <Tag
              $platform-web={{
                alignSelf: 'center',
                backgroundColor: '$grey.300',
              }}
              leftIcon="flash"
            >
              {highlight}
            </Tag>
          ) : null}
        </XStack>

        {description ? (
          <Box height="44px" textAlign="left">
            <Typography.Text variant="secondary">{description}</Typography.Text>
          </Box>
        ) : null}
      </YStack>
      {children}
    </YStack>
  );
};
